import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TrackStats } from '../../models/brouter-map.model';
import {
  formatDistanceKm,
  formatDistanceKmPrecise,
  formatDuration,
  formatDurationWithSeconds,
  formatEnergyKWh,
  formatMeanEnergy
} from '../../services/track-stats';

/**
 * Port of the legacy `#stats` footer bar.
 *
 * Values are locale-formatted here rather than in the stats service, so the service
 * stays pure and directly comparable against the legacy calculations.
 */
@Component({
  selector: 'app-stats-footer',
  imports: [TranslateModule],
  templateUrl: './stats-footer.component.html',
  styleUrl: './stats-footer.component.scss'
})
export class StatsFooterComponent {
  readonly stats = input.required<TrackStats>();

  readonly distance = computed(() => formatDistanceKm(this.stats().distance).toLocaleString());
  readonly distancePrecise = computed(() =>
    formatDistanceKmPrecise(this.stats().distance).toLocaleString(undefined, {
      minimumFractionDigits: 3
    })
  );

  readonly totalTime = computed(() => formatDuration(this.stats().totalTime));
  readonly totalTimePrecise = computed(() => formatDurationWithSeconds(this.stats().totalTime));

  readonly totalEnergy = computed(() => formatEnergyKWh(this.stats().totalEnergy).toLocaleString());
  readonly meanEnergy = computed(() =>
    formatMeanEnergy(this.stats().totalEnergy, this.stats().distance).toLocaleString()
  );

  readonly ascend = computed(() => this.stats().ascend.toLocaleString());
  readonly plainAscend = computed(() => this.stats().plainAscend.toLocaleString());
  readonly cost = computed(() => this.stats().cost.toLocaleString());
  readonly meanCostFactor = computed(() => this.stats().meanCostFactor.toLocaleString());

  readonly hasTrack = computed(() => this.stats().distance > 0);
}
